// gatsby-browser.js
export const onInitialClientRender = () => {
  const path = window.location.pathname;
  if (path === "/error" || path === "/admin" || path.startsWith("/admin/")) return;

  let inIframe = false;
  try {
    inIframe = window.self !== window.top;
  } catch (e) {
    // Cross-origin iframe - access to window.top is blocked, so we are in an iframe
    inIframe = true;
  }

  if (!inIframe) {
    window.location.replace("/error");
  }
}
